import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import UserInitializationContext from '|/context/user-initialization-context';

const ProtectedRoute: React.FC<React.PropsWithChildren<{}>> = ({ children }) => {
  const { accessToken } = useContext(UserInitializationContext);

  if (accessToken?.user?.name === undefined) {
    return <Navigate to="/account" />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
